<!-- Cost breakdown Modal -->
@if(assignmentCreateData)
{
<div class="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
  <div class="popup-header">
    <div class="row">
      <div class="col-8 text-left">
        <!-- <h3 class="modal-title">
          {{ 'create-assignment-summary-data.cost-breakdown' | translate }}
        </h3> -->
      </div>
      <div class="col-4 text-right" (click)="closeModal()" style="cursor: pointer;">
        <span class="close">
          <img src="/assets/img/Close.svg" alt="Close" style="width: 12px; height: 12px; object-fit: contain;"
            loading="lazy" />
        </span>
      </div>
    </div>
  </div>
  <div style=" height: 1px;
    background-color: #e5e7eb;
    margin-top : -21px "></div>
  <div class="popup-body" style="margin: 9px;">
    <p class="faded-p">
      {{ 'create-assignment-summary-data.modal-description' | translate }}
    </p>
    <p class="faded-p">
      {{ 'create-assignment-summary-data.modal-description1' | translate }}
    </p>
    <p class="faded-p" style="margin-top: -16px;">
      {{ 'create-assignment-summary-data.modal-description2' | translate }}
    </p>

    <!-- <div class="line"></div> -->

    <div class="scroll-div">
      <table class="cost-table" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th style="text-align: left; padding: 8px;">{{ 'create-assignment-summary-data.shift-date' | translate }}
            </th>
            <th style="text-align: left; padding: 8px; text-align: center">{{ 'create-assignment-summary-data.num-guards' | translate }}
            </th>
            <th style="text-align: left; padding: 8px;text-align: center">{{ 'create-assignment-summary-data.total-hours' | translate }}
            </th>
            <th style="text-align: left; padding: 8px;text-align: center">{{ 'create-assignment-summary-data.cost-per-guard-hour' |
              translate }}</th>
            <th style="text-align: left; padding: 8px;text-align: center">{{ 'create-assignment-summary-data.total-cost-per-shift' |
              translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dateWithPrice of summaryData.datesWithPrice">
            <td style="padding: 8px;">{{ dateWithPrice.date | date }}</td>
            <td style="padding: 8px; text-align: center">
              {{ summaryData.guardsNumber }}
            </td>
            <td style="padding: 8px;text-align: center">
              {{ dateWithPrice.duration }}
           </td>
            <td style="padding: 8px;text-align: center"> {{ getRatePerHour(dateWithPrice) | currencyFormat }}</td>
            <td style="padding: 8px;text-align: center">{{ (dateWithPrice.customerPerShift | currencyFormat) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="line"></div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-6">
        <p class="faded-p" style="color :#033b87; font-weight: 600;">{{ 'create-assignment-summary-data.excluding-vat' |
          translate }}</p>
      </div>
      <div class="col-6">
        <div class="cost-wrapper">
          <p class="bold-faded">*{{ 'create-assignment-summary-data.total-cost' | translate }}</p>
          <p class="total-price">{{ (summaryData.estimatedPrice | currencyFormat) }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
}
<!-- Shared assignment summar -->

@else{
<div class="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
  <h3 class="font-bold text-gray-900 mb-4" style="font-weight: 700;">{{'guard-shift-details.common.total-cost' |
    translate}}</h3>
  <div class="space-y-3">
    <div class="flex justify-between text-sm">
      <span class="text-gray-800">{{'guard-shift-details.common.hourly-rate-per-guard' | translate}}:</span>
      <span class="font-semibold text-right"> {{ CalculationGuardPerHoursRate(costPerGuard, duration) }} kr/h</span>
    </div>

    <div class="flex justify-between text-sm">
      <span class="text-gray-800">{{'guard-shift-details.common.number-of-hours' | translate}}:</span>
      <span class="font-semibold text-right">
        @if(duration) { {{duration}}h } @else{ - }
      </span>
    </div>
    <div class="flex justify-between text-sm">
      <span class="text-gray-800">{{'guard-shift-details.common.number-of-guards' | translate}}:</span>
      <span class="font-semibold text-right">
        @if(guardCount) { {{guardCount}} } @else{ - }
      </span>
    </div>
    <div class="flex justify-between text-sm">
      <span class="text-gray-800">{{'guard-shift-details.common.excluding-subsection' | translate}}:</span>
      <span class="font-semibold text-right" *ngIf="totalCost !== undefined && totalCost !== null; else noCost"> 
        {{ totalCost | currencyFormat }}
      </span>
      <ng-template #noCost>
        -
      </ng-template>
    </div>
    <div class="flex justify-between text-sm">
      <span class="text-gray-800">{{'guard-shift-details.common.vat' | translate}} (25%):</span>
      <span class="font-semibold text-right"> {{ vatAmount | currencyFormat }}</span>
    </div>
    <div class="flex justify-between text-sm md:text-lg font-bold text-green-600 mt-2 pt-2 border-t border-gray-200">
      <span>{{ 'guard-shift-details.common.total-cost' | translate }} (inkl. {{ 'guard-shift-details.common.vat' |
        translate }}):</span>
      <span>
        {{ calculationSubSection(totalCost) | currencyFormat }}
      </span>
    </div>
  </div>
</div>
}